module.exports = {"340207001":"四褐山街道","340207002":"裕溪口街道","340207003":"官陡街道","340207004":"湾里街道","340207005":"清水街道","340207101":"沈巷镇","340207102":"二坝镇","340207103":"汤沟镇","340207104":"白茆镇","340207401":"安徽省江北产业集中区","340207402":"安徽芜湖鸠江经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340207.json
// module id = 966
// module chunks = 0